'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetchOneByVacancyId (vacancyId) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/video_interviews', {params: {vacancy_id: vacancyId}})
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  updateOne (model) {
    return Axios.put('/1.0/video_interviews', {video_interviews: [model]})
      .then(response => parseResponse(response).data[0])
      .catch(err => {
        throw handleError(err)
      })
  },

  storeQuestions (videointerviewId, models) {
    return new Promise((resolve, reject) => {
      Axios.post(`/1.0/video_interviews/${videointerviewId}/questions`, {questions: models})
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  updateQuestions (videointerviewId, models) {
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/video_interviews/${videointerviewId}/questions`, {questions: models})
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  removeQuestions (videointerviewId, models) {
    return new Promise((resolve, reject) => {
      Axios.delete(`/1.0/video_interviews/${videointerviewId}/questions`, {data: {questions: models.map(model => ({id: model.id}))}})
        .then(() => resolve())
        .catch(err => reject(handleError(err)))
    })
  }
}
